export default __webpack_public_path__ + "static/media/food-3.3c02ec10.png";